/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { post } from '../../../services/GenesisApi';
import { ITradeFilter, ITradingData } from '../../../types/Trading.type';
import { handleError, sortByManualDeals } from '../../../utils/common/utils';
import { GET_TRADING_DATA } from '../../../constants/Trade';

export interface ITradingState {
  loading: boolean;
  tradings: ITradingData[];
}

export const initialState: ITradingState = {
  loading: false,
  tradings: [],
};

export const getTradings = createAsyncThunk(
  'trading/getTradings',
  async ({ filters }: { filters: ITradeFilter }) => {
    return post(GET_TRADING_DATA, filters)
      .then((response) => {
        const data = response.data || [];
        return sortByManualDeals(
          data.map((_) => {
            return {
              ..._,
              activity: /^[1-9]\d*$/.test(_.activity)
                ? Number(_.activity)
                : _.activity,
              quantityInKwh: _.quantity,
            };
          })
        );
      })
      .catch((error) => {
        handleError(error, 'Error fetching trading data!');
        throw error;
      });
  }
);

const trading = createSlice({
  name: 'trading',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTradings.pending, (state: ITradingState) => {
        state.loading = true;
        state.tradings = [];
      })
      .addCase(
        getTradings.fulfilled,
        (state: ITradingState, { payload }: PayloadAction<ITradingData[]>) => {
          state.loading = false;
          state.tradings = payload;
        }
      )
      .addCase(getTradings.rejected, (state: ITradingState) => {
        state.loading = false;
        state.tradings = [];
      });
  },
});

export const tradingActions = trading.actions;
export default trading.reducer;
